export function getAccountfromUrl(url: string) {
  const possibleId = url.split('/').filter(Boolean).shift();
  if (possibleId?.startsWith('p-')) {
    return possibleId?.slice(2);
  }
  return null;
}
